var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostframe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35416"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 261",
    x1: 2,
    y1: 2.5,
    x2: 22,
    y2: 2.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 262",
    x1: 2,
    y1: 9.5,
    x2: 22,
    y2: 9.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 266",
    x1: 2,
    y1: 15.5,
    x2: 22,
    y2: 15.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 263",
    x1: 2,
    y1: 21.5,
    x2: 22,
    y2: 21.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 264",
    x1: 21.5,
    y1: 22,
    x2: 21.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 265",
    x1: 2.5,
    y1: 22,
    x2: 2.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 267",
    x1: 8.5,
    y1: 22,
    x2: 8.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 268",
    x1: 15.5,
    y1: 22,
    x2: 15.5,
    y2: 2,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostframe);
export default __webpack_public_path__ + "static/media/postframe.8eceadc0afe446dbfcae95a31d593987.svg";
export { ForwardRef as ReactComponent };